import React from "react";
import { useParams } from "react-router-dom";
import HeaderLayout from "components/Common/Header/HeaderLayout";
import SideBarLayout from "components/Common/SideBar/SideBarLayout";
import RosterConfigInputs from "components/RosterConfig/RosterConfigInputs";

import { Box } from "@mui/material";
import "@fontsource/urbanist";

const RosterConfig = () => {
  const { type, classRosterId, classRequestId, data } = useParams();

  return (
    <Box display="flex">
      <SideBarLayout />
      <HeaderLayout />
      <Box sx={{ paddingTop: "64px" }}>
        <RosterConfigInputs
          type={type}
          classRosterId={classRosterId}
          classRequestId={classRequestId}
          data={data}
        />
      </Box>
    </Box>
  );
};

export default RosterConfig;
